export const STATS_VIEWS = {
    FLIGHT: 'flight',
    CAMPAIGN: 'campaign',
};
